export const PropertyNodeSize = 4
export const EventRadius = 8